import { currencyApi } from '../../api/currencyApi'

import { addNotification } from './notificationActions'

import { currenciesSignal, currenciesErrorSignal, currenciesLoadedSignal } from '../signals/currencySignals'

import { HardCodedCurrencies } from '../../utils/constants'

export const fetchCurrencies = async (config, accessToken, debug = false) => {
	currenciesLoadedSignal.value = false
	currenciesSignal.value = []
	return await currencyApi.fetchCurrencies(config, accessToken, true).then(
		(currencies) => {
			currenciesSignal.value = currencies
			currenciesLoadedSignal.value = true
			return currenciesSignal.value
		}
	).catch(
		(err) => {
			if (debug) {
				console.log("Returning hard coded currencies")
				currenciesSignal.value = HardCodedCurrencies
				currenciesLoadedSignal.value = true
				return currenciesSignal.value
			}
			else {
				currenciesErrorSignal.value = err
				console.log(err)
				addNotification(`Unable to load currencies due to the following error - ${err}`)
			}
		}
	)
}